import type { IFontInfo } from "./IFontInfo"
export const BUILT_IN_FONTS: IFontInfo[] = [
  { family: "SimSun", name: "宋体", desc: "宋体" },
  { family: "SimHei", name: "黑体", desc: "黑体" },
  { family: "Microsoft Yahei", name: "微软雅黑", desc: "微软雅黑" },
  { family: "Microsoft JhengHei", name: "微软正黑体", desc: "微软正黑体" },
  { family: "KaiTi", name: "楷体", desc: "楷体" },
  { family: "NSimSun", name: "新宋体", desc: "新宋体" },
  { family: "FangSong", name: "仿宋", desc: "仿宋" },
  { family: "PingFang SC", name: "苹方", desc: "苹方" },
  { family: "STHeiti", name: "华文黑体", desc: "华文黑体" },
  { family: "STKaiti", name: "华文楷体", desc: "华文楷体" },
  { family: "STSong", name: "华文宋体", desc: "华文宋体" },
  { family: "STFangsong", name: "华文仿宋", desc: "华文仿宋" },
  { family: "STZhongsong", name: "华文中宋", desc: "华文中宋" },
  { family: "STHupo", name: "华文琥珀", desc: "华文琥珀" },
  { family: "STXinwei", name: "华文新魏", desc: "华文新魏" },
  { family: "STLiti", name: "华文隶书", desc: "华文隶书" },
  { family: "STXingkai", name: "华文行楷", desc: "华文行楷" },
  { family: "Hiragino Sans GB", name: "冬青黑体简", desc: "冬青黑体简" },
  { family: "Lantinghei SC", name: "兰亭黑-简", desc: "兰亭黑-简" },
  { family: "Hanzipen SC", name: "翩翩体-简", desc: "翩翩体-简" },
  { family: "Hannotate SC", name: "手札体-简", desc: "手札体-简" },
  { family: "Songti SC", name: "宋体-简", desc: "宋体-简" },
  { family: "Wawati SC", name: "娃娃体-简", desc: "娃娃体-简" },
  { family: "Weibei SC", name: "魏碑-简", desc: "魏碑-简" },
  { family: "Xingkai SC", name: "行楷-简", desc: "行楷-简" },
  { family: "Yapi SC", name: "雅痞-简", desc: "雅痞-简" },
  { family: "Yuanti SC", name: "圆体-简", desc: "圆体-简" },
  { family: "YouYuan", name: "幼圆", desc: "幼圆" },
  { family: "LiSu", name: "隶书", desc: "隶书" },
  { family: "STXihei", name: "华文细黑", desc: "华文细黑" },
  { family: "STCaiyun", name: "华文彩云", desc: "华文彩云" },
  { family: "FZShuTi", name: "方正舒体", desc: "方正舒体" },
  { family: "FZYaoti", name: "方正姚体", desc: "方正姚体" },
]